import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../Api";

export const getSchedule = createAsyncThunk("getSchedules", async (d) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_URL}/schedule/all/${d}`
    );
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});

export const onDemandUpdate = createAsyncThunk(
  "onDemandUpdate",
  async (n, { dispatch }) => {
    try {
      const res = await api.get(
        `${process.env.REACT_APP_BASE_URL}/auth/mergeresponses`
      );
      await dispatch(getCount());
      return {};
    } catch (error) {
      throw error;
    }
  }
);
export const getCount = createAsyncThunk("getCount", async () => {
  try {
    const res = await api.get(`${process.env.REACT_APP_BASE_URL}/auth/count`);
    return { data: res.data.results };
  } catch (error) {
    throw error;
  }
});

export const forceUpdate = createAsyncThunk(
  "forceUpdate",
  async (d, { dispatch }) => {
    try {
      const res = await api.post(
        `${process.env.REACT_APP_BASE_URL}/schedule/create`,
        d
      );
      await dispatch(getSchedule(1));
      await dispatch(getCount());
      return { data: res.data };
    } catch (error) {
      throw error;
    }
  }
);

const scheduleSlice = createSlice({
  name: "schedule",
  initialState: {
    data: {},
    count: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
    errMsg: "",
    isUpdated: false,
    isUpdateError:false
  },
  reducers: {
    reset: (state) => {
      state.isError = false;
      state.isUpdateError = false;
      state.errMsg = "";
      state.isSuccess = false;
      state.isUpdated=false
    },
  },
  extraReducers: (builder) => {
    // Get Schedule
    builder.addCase(getSchedule.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSchedule.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload.data || {};
    });
    builder.addCase(getSchedule.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
    //  Demand Update
    builder.addCase(onDemandUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(onDemandUpdate.fulfilled, (state, action) => {
      state.isLoading = false;
      state.isUpdated = true;
    });
    builder.addCase(onDemandUpdate.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });
    // Count
    builder.addCase(getCount.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getCount.fulfilled, (state, action) => {
      state.isLoading = false;
      state.count = action.payload.data;
    });
    builder.addCase(getCount.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = "Error Occurred";
    });

    builder.addCase(forceUpdate.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(forceUpdate.fulfilled, (state, action) => {
      state.isLoading = false;

      state.isSuccess = true;
    });
    builder.addCase(forceUpdate.rejected, (state, action) => {
      state.isLoading = false;
      state.isUpdateError = true;
      state.errMsg = "Error Occurred";
    });
  },
});

export const scheduleReducer = scheduleSlice.reducer;
export const { reset } = scheduleSlice.actions;
